/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2022-07-08 10:00:59
 * @LastEditors: hongye
 * @LastEditTime: 2025-09-18 16:38:21
 */
import { createApp } from 'vue'
import App from '@/App.vue'
import registerPlugin from '@/plugins/index'
import store from '@/store/store'
import router from './router'
import directive from '@/directive/index'
import registerCompoent from '@/components/index'
import { changeResizeColumn, currencyMap, lang } from '@/utils'
import { loadMonitorSDK } from '@/utils/monitor'
import request from '@/service/request'
import '@/assets/iconfont/iconfont.css'
import 'virtual:svg-icons-register'

// 加载Bonree APM监控SDK
loadMonitorSDK({
  data: '%7B%22reqHeaderTraceKey%22%3A%5B%22tracestate%22%2C%22traceparent%22%5D%2C%22pendingRequestTimeout%22%3A30000%2C%22uploadAddrHttps%22%3A%22https%3A%2F%2Fjmsmy-bonree-apm.jtexpress.my%2FRUM%2Fupload%22%2C%22probability%22%3A1000%2C%22mc%22%3A%5B%7B%22n%22%3A%22network%22%2C%22cs%22%3A%7B%22fc%22%3A0%7D%7D%5D%2C%22appId%22%3A%22bf39edee8f5b4cb8ad096833236c0f04%22%2C%22uploadAddrHttp%22%3A%22http%3A%2F%2Fjmsmy-bonree-apm.jtexpress.my%2FRUM%2Fupload%22%2C%22hcs%22%3A2%2C%22respHeaderTraceKey%22%3A%5B%22traceresponse%22%2C%22x-br-response%22%5D%2C%22brss%22%3Afalse%7D'
})

const app = createApp(App)
const packageList = [store, router, registerCompoent, directive]
packageList.forEach((p) => app.use(p))
//按需注册全局组件
registerPlugin(app)
import '@/assets/style/common.less'
app.config.globalProperties.$lang = lang
app.config.globalProperties.$req = request
app.config.globalProperties.$changeResizeColumn = changeResizeColumn
app.config.globalProperties.$currencyMap = currencyMap
app.mount('#app')